import { render, staticRenderFns } from "./AgreementItem.vue?vue&type=template&id=73421896&"
import script from "./AgreementItem.vue?vue&type=script&lang=js&"
export * from "./AgreementItem.vue?vue&type=script&lang=js&"
import style0 from "./AgreementItem.vue?vue&type=style&index=0&id=73421896&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports